// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { ProductReferenceDto } from '@epicuro-next/data/engagement/engagement-models';
import { SearchQuery } from 'graphql-api/gql-api-interfaces';

import { BrandOrgType } from '../../common/bought-this-season/brand-org';

export const squarePanelListProviderRemovePrefixTransformer = {
  id: 'square-panel-products-data-container',
  data: {
    loadingStateWrapper: {
      property: {
        transform: function ([productReferences, brandOrg]: [
          ProductReferenceDto[],
          BrandOrgType,
        ]): SearchQuery {
          const brandId = brandOrg?.brandId;
          const searchQuery: SearchQuery = {
            productReferences: productReferences.map((pr) => {
              const productId = pr.productId;
              return {
                productId,
                brandId,
              };
            }),
            useV2Search: true,
            available: true,
            num: Math.min(productReferences.length, 100),
          };
          return searchQuery;
        }.toString(),
      },
    },
  },
};
